import { render, staticRenderFns } from "./assignArm.vue?vue&type=template&id=8b08783a&"
import script from "./assignArm.vue?vue&type=script&lang=js&"
export * from "./assignArm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports